<template>
    <span class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm whitespace-nowrap font-bold"
          :class="[colorClasses, {'uppercase': uppercase}]"
    >
      <slot/>
    </span>
</template>

<script>
export default {
    name: 'element-badge',

    props: {
        color: {
            type: String,
            default: 'gray',
        },
        uppercase: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        colorClasses() {
            switch (this.color) {
                case 'gray':
                    return 'bg-gray-100 border-gray-200 text-gray-800 dark:bg-gray-800 dark:border-gray-900 dark:text-gray-100';
                case 'red':
                    return 'bg-red-100 border-red-200 text-red-800 dark:bg-red-800 dark:border-red-900 dark:text-red-100';
                case 'green':
                    return 'bg-green-100 border-green-200 text-green-800 dark:bg-green-800 dark:border-green-900 dark:text-green-100';
                case 'cyan':
                    return 'bg-cyan-100 border-cyan-200 text-cyan-800 dark:bg-cyan-800 dark:border-cyan-900 dark:text-cyan-100';
                case 'orange':
                    return 'bg-orange-100 border-orange-200 text-orange-800 dark:bg-orange-800 dark:border-orange-900 dark:text-orange-100';
                case 'pink':
                    return 'bg-pink-100 border-pink-200 text-pink-800 dark:bg-pink-800 dark:border-pink-900 dark:text-pink-100';
                case 'rose':
                    return 'bg-rose-100 border-rose-200 text-rose-800 dark:bg-rose-800 dark:border-rose-900 dark:text-rose-100';
                case 'blue':
                    return 'bg-blue-100 border-blue-200 text-blue-800 dark:bg-blue-800 dark:border-blue-900 dark:text-blue-100';
                case 'indigo':
                    return 'bg-indigo-100 border-indigo-200 text-indigo-800 dark:bg-indigo-800 dark:border-indigo-900 dark:text-indigo-100';
                case 'purple':
                    return 'bg-purple-100 border-purple-200 text-purple-800 dark:bg-purple-800 dark:border-purple-900 dark:text-purple-100';
                case 'yellow':
                    return 'bg-yellow-100 border-yellow-200 text-yellow-800 dark:bg-yellow-600 dark:border-yellow-700 dark:text-yellow-100';
                case 'lime':
                    return 'bg-lime-100 border-lime-200 text-lime-800 dark:bg-lime-800 dark:border-lime-900 dark:text-lime-100';
                case 'emerald':
                    return 'bg-emerald-100 border-emerald-200 text-emerald-800 dark:bg-emerald-800 dark:border-emerald-900 dark:text-emerald-100';
                case 'teal':
                    return 'bg-teal-100 border-teal-200 text-teal-800 dark:bg-teal-800 dark:border-teal-900 dark:text-teal-100';
                default:
                    return 'bg-gray-100 border-gray-200 text-gray-800 dark:bg-gray-800 dark:border-gray-900 dark:text-gray-100';
            }
        }
    }
};
</script>
